import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import logo from '../../images/logo/logo.jpeg';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Main Footer */}
      <div className="footer-main">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-company-info">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <img src={logo} alt="KirBOO Flowsafe Logo" className="footer-logo-img" />
              </div>
              <div>
                <h3 className="footer-brand">KirBOO</h3>
                <p className="footer-subtitle">Flowsafe Pvt Ltd</p>
              </div>
            </div>
            <p className="footer-description">
              Your trusted partner in High-pressure valves, Electric & Pneumatic actuators, 
              Pump Services and spare parts support with 24/7 technical assistance.
            </p>
            <div className="footer-social-links">
              <a href="https://facebook.com/kirbooflowsafe" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://twitter.com/kirbooflowsafe" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://linkedin.com/company/kirbooflowsafe" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://instagram.com/kirbooflowsafe" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-section-title">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/" className="footer-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="footer-link">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/careers" className="footer-link">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/our-clients" className="footer-link">
                  Our Clients
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-section-title">Our Services</h4>
            <ul className="footer-links">
              <li>
                <Link to="/services/safety-valve" className="footer-link">
                  Safety Valve & Breather Valves
                </Link>
              </li>
              <li>
                <Link to="/services/valve-service" className="footer-link">
                  Control & Isolation Valves
                </Link>
              </li>
              <li>
                <Link to="/services/arc-valve" className="footer-link">
                  ARC Valve Service
                </Link>
              </li>
              <li>
                <Link to="/services/actuator" className="footer-link">
                  Actuator and positioners services
                </Link>
              </li>
              <li>
                <Link to="/services/bfp-service" className="footer-link">
                  Pump Services
                </Link>
              </li>
              <li>
                <Link to="/services/spares" className="footer-link">
                  Spare Parts Support
                </Link>
              </li>
              <li>
                <Link to="/services/workshop" className="footer-link">
                  Workshop Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-section-title">Contact Info</h4>
            <div className="footer-contact-info">
              <div className="footer-contact-item">
                <Phone className="w-5 h-5 text-blue-400" />
                <div>
                  <div className="footer-contact-label">Contact</div>
                  <a href="tel:+918329392431" className="footer-contact-value hover:underline">
                    +91 8329392431
                  </a>
                </div>
              </div>

              <div className="footer-contact-item">
                <Phone className="w-5 h-5 text-blue-400" />
                <div>
                  <div className="footer-contact-label">Office</div>
                  <a href="tel:+912244505126" className="footer-contact-value hover:underline">
                    022-44505126
                  </a>
                </div>
              </div>
              
              <div className="footer-contact-item">
                <Mail className="w-5 h-5 text-blue-400" />
                <div>
                  <div className="footer-contact-label">Mail</div>
                  <a href="mailto:kirbooindia@gmail.com" className="footer-contact-value hover:underline">
                    kirbooindia@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="footer-contact-item">
                <MapPin className="w-5 h-5 text-blue-400" />
                <div>
                  <div className="footer-contact-label">Registered Office</div>
                  <div className="footer-contact-value">C26/02, Panchatara, Sector 15, Airoli, Navi Mumbai – 400708</div>
                </div>
              </div>
              
              <div className="footer-contact-item">
                <MapPin className="w-5 h-5 text-blue-400" />
                <div>
                  <div className="footer-contact-label">Works Address</div>
                  <div className="footer-contact-value">Gat No. 265/1, Shinganapur road, Natepute, Tal – Malshiras, Dist – Solapur - 413109</div>
                </div>
              </div>
              
              <div className="footer-contact-item">
                <Clock className="w-5 h-5 text-blue-400" />
                <div>
                  <div className="footer-contact-label">Support Hours</div>
                  <div className="footer-contact-value">24/7 Available</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container-custom px-4 py-6">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              © 2026 KirBOO Flowsafe Pvt Ltd. All rights reserved.
            </div>
            <div className="footer-company-details">
              <span className="footer-detail">GST: 27AAJCK4096N1ZS</span>
              <span className="footer-detail">CIN: U29256MH2022PTC376818</span>
              <span className="footer-detail">ISO: 9001:2015</span>
            </div>
            <div className="footer-bottom-links">
              <Link to="/privacy" className="footer-bottom-link">
                Privacy Policy
              </Link>
              <Link to="/terms" className="footer-bottom-link">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

